import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

export default function OfferPage() {
  return (
    <LegalDocumentPage
      slug="offer"
      fallbackTitle="Публичная оферта"
      fallbackFile="/docs/offer.html"
    />
  );
}
